import { Context } from 'effect';
/**
 * Simple service to wrap reading from the Prolog Rule store
 */
export class PrologRuleService extends Context.Tag('@fixtuur/backpack/PrologRuleService')() {
}
